export const btnIconList= [
    {
        "id": 1,
        "original_english": "Accounts & Bills",
        "english": "Accounts & Bills",
        "original_arabic": "الحسابات والفواتير",
        "arabic": "الحسابات والفواتير",
        "btns": "accounts_bills"
    },
    {
        "id": 2,
        "original_english": "Report an Outage",
        "english": "Report an Outage",
        "original_arabic": "بلاغ انقطاع الخدمة الكهربائية",
        "arabic": "بلاغ انقطاع الخدمة الكهربائية",
        "btns": "report_an_outage"
    },
    {
        "id": 3,
        "original_english": "Track Requests",
        "english": "Track Requests",
        "original_arabic": "متابعة الطلبات",
        "arabic": "متابعة الطلبات",
        "btns": "track_requests"
    },
    {
        "id": 4,
        "original_english": "Safety Services",
        "english": "Safety Services",
        "original_arabic": "خدمات لسلامتك",
        "arabic": "خدمات لسلامتك",
        "btns": "safety_services"
    },
    {
        "id": 5,
        "original_english": "Agent Support",
        "english": "Agent Support",
        "original_arabic": "الدعم",
        "arabic": "الدعم",
        "btns": "agent_support"
    },
    {
        "id": 6,
        "original_english": "Account Information",
        "english": "Account Information",
        "original_arabic": "معلومات عن الحساب",
        "arabic": "معلومات عن الحساب",
        "btns": "account_information"
    },
    {
        "id": 7,
        "original_english": "Bill Information",
        "english": "Bill Information",
        "original_arabic": "معلومات عن الفاتورة",
        "arabic": "معلومات عن الفاتورة",
        "btns": "bill_information"
    },
    {
        "id": 8,
        "original_english": "Fixed bill",
        "english": "Fixed bill",
        "original_arabic": "الفاتورة الثابتة",
        "arabic": "الفاتورة الثابتة",
        "btns": "fixed_bill"
    },
    {
        "id": 9,
        "original_english": "Report an Outage",
        "english": "Report an Outage",
        "original_arabic": "بلاغ انقطاع الخدمة الكهربائية",
        "arabic": "بلاغ انقطاع الخدمة الكهربائية",
        "btns": "report_an_outage"
    },
    {
        "id": 10,
        "original_english": "Electricity Connection Request",
        "english": "Electricity Connection Request",
        "original_arabic": "طلب خدمة كهربائية",
        "arabic": "طلب خدمة كهربائية",
        "btns": "electricity_connection_request"
    },
    {
        "id": 11,
        "original_english": "Tickets & Requests",
        "english": "Tickets & Requests",
        "original_arabic": "التذاكر والطلبات",
        "arabic": "التذاكر والطلبات",
        "btns": "tickets_requests"
    },
    {
        "id": 12,
        "original_english": "Alkahraba Friend",
        "english": "Alkahraba Friend",
        "original_arabic": "صديق الكهرباء",
        "arabic": "صديق الكهرباء",
        "btns": "alkahraba_friend"
    },
    {
        "id": 13,
        "original_english": "Aamin",
        "english": "Aamin",
        "original_arabic": "آمن",
        "arabic": "آمن",
        "btns": "aamin"
    },
    {
        "id": 14,
        "original_english": "Report an Outage",
        "english": "Report an outage",
        "original_arabic": "الابلاغ عن انقطاع الخدمة الكهربائية",
        "arabic":"الابلاغ عن انقطاع الخدمة الكهربائية",
        "btns": "report_an_outage"
    },
    {
        "id": 15,
        "original_english": "Inquiries and Complaints",
        "english": "Inquiries and Complaints",
        "original_arabic": "للاستفسارات والشكاوى",
        "arabic": "للاستفسارات والشكاوى",
        "btns": "inquiries_and_complaints"
    },
];